<script type="text/javascript">
// 弹窗开关
const DIALOG_VISIBLE = 'dialog_visible'
const DIALOG_VISIBLE_CENTER = 'dialog_visible_center'
// 路由名称
const ROUTER_NAME = 'router_name'
// 用户信息
const USER_DATA = 'user_data'
// 注销
const LOGOUT = 'logout'
// token
const TOKEN = 'token'
// 用户表
const USER_TABLE = 'user_table'
// 登录错次数
const LOGIN_ERROR_COUNT = 'login_error_count'
// 是否需要清空表单
const ACTIVATED_ORG = 'activated_org'
const ACTIVATED_USER = 'activated_user'
const ACTIVATED_ROLE = 'activated_role'
const ACTIVATED_POSITION = 'activated_position'
const ACTIVATED_MENU = 'activated_menu'
const ACTIVATED_UPCOMING = 'activated_upcoming'
const ACTIVATED_CONTENT = 'activated_content'
const ACTIVATED_BULKMAIL = 'activated_bulkmail'
const TODO_TASK = 'todo_task'
const QUICK_MENU = 'quick_menu'
const HEADER_IMG = 'header_img'
const BUSINESS_EDIT = 'business_edit'
// 通知培训师管理页面执行初始化方法
const TRAINER_INFO = 'trainer_info'

// 通知场地信息页面执行初始化方法
const SITE_INFO = 'site_info'
// 通知教室信息页面执行初始化方法
const CLASSROOM_INFO = 'classroom_info'
// 通知车辆信息页面执行初始化方法
const VEHICLE_INFO = 'vehicle_info'
// 通知部门页面执行初始化方法
const OCHART_DEPARTMENT = 'ochart_department'
// 经销商模板页面执行初始化方法
const ORGTEMP_MANAGER = 'orgtemp_manager'
// 课程与车辆关系页面执行初始化方法
const COURSE_VEHICALERELA = 'course_vehicalerela'
// 组织架构一级页面初始化方法
const ORG_TREE_ONE = 'org_tree_one'
// 菜单名称
const MENU_LIST = 'menu_list'
// 首页变更
const HOME = 'home'
// 消息通知
const TODO_NOTIFY = 'todo_notify'
// 租户类别ID
const TENANT_ID = "tenantId"
// 白名单访问数据源
const ACCESS_WHITELIST_DS = "Access-Whitelist-DS"

function isEmpty(obj) {
  if (typeof obj === 'undefined' || obj === null || obj === '') {
    return true
  } else {
    return false
  }
}

export default
  {
    ROUTER_NAME,
    DIALOG_VISIBLE,
    USER_TABLE,
    USER_DATA,
    LOGOUT,
    isEmpty,
    LOGIN_ERROR_COUNT,
    ACTIVATED_ORG,
    ACTIVATED_ROLE,
    TRAINER_INFO,
    ACTIVATED_USER,
    ACTIVATED_POSITION,
    ACTIVATED_MENU,
    ACTIVATED_UPCOMING,
    ACTIVATED_CONTENT,
    ACTIVATED_BULKMAIL,
    TOKEN,
    TODO_TASK,
    QUICK_MENU,
    HEADER_IMG,
    MENU_LIST,
    HOME,
    BUSINESS_EDIT,
    SITE_INFO,
    CLASSROOM_INFO,
    VEHICLE_INFO,
    OCHART_DEPARTMENT,
    ORGTEMP_MANAGER,
    COURSE_VEHICALERELA,
    ORG_TREE_ONE,
    TODO_NOTIFY,
    TENANT_ID,
    ACCESS_WHITELIST_DS,
    DIALOG_VISIBLE_CENTER
  }
</script>
